import { IconEye, IconX, IconCircleCheck } from '@tabler/icons-react';
import { Text } from '@mantine/core';
import type { AIMessage } from '~/common/vm/protocol';
import { CollapsibleCard } from '../CollapsibleCard';

export function AIVisualAssertionStartCard({
  message,
}: {
  message: Extract<AIMessage, { type: 'ai-assertion-start' }>;
}) {
  return (
    <CollapsibleCard
      icon={IconEye}
      title="Visual Assertion"
      defaultExpanded={true}
      classNames={{
        icon: 'text-gray-500 dark:text-gray-400',
      }}
    >
      <div className="mx-1 rounded border border-gray-200 bg-gray-50 px-3 py-1.5 dark:border-gray-700 dark:bg-gray-800">
        <Text
          size="sm"
          className="italic leading-relaxed"
        >
          &quot;{message.content}&quot;
        </Text>
      </div>
    </CollapsibleCard>
  );
}

export function AIVisualAssertionResultCard({
  message,
}: {
  message: Extract<AIMessage, { type: 'ai-assertion-result' }>;
}) {
  const config =
    message.isCorrect ?
      {
        iconClassName: 'text-gray-500 dark:text-gray-400',
        icon: IconCircleCheck,
        title: 'Visual Assertion Passed',
      }
    : {
        iconClassName: 'text-gray-500 dark:text-gray-400',
        icon: IconX,
        title: 'Assertion Failed',
      };

  return (
    <CollapsibleCard
      icon={config.icon}
      title={config.title}
      defaultExpanded={true}
      classNames={{
        icon: config.iconClassName,
      }}
    />
  );
}

export function AIConditionalBlockResultCard({
  message,
}: {
  message: Extract<AIMessage, { type: 'conditional-evaluation-result' }>;
}) {
  const config =
    message.resolvedTo ?
      {
        iconClassName: 'text-gray-500 dark:text-gray-400',
        icon: IconCircleCheck,
        title: 'Conditional is true',
      }
    : {
        iconClassName: 'text-gray-500 dark:text-gray-400',
        icon: IconX,
        title: 'Conditional is false',
      };

  return (
    <CollapsibleCard
      icon={config.icon}
      title={config.title}
      defaultExpanded={true}
      classNames={{
        icon: config.iconClassName,
      }}
    />
  );
}
